import { createSignal } from '@verclam/pulsar';

/** Whether the second-factor screen shows the recovery-code field instead of the TOTP code field. */
const recoveryCodeModeSignal = createSignal<boolean>(false);

export const setRecoveryCodeMode = (isRecoveryCodeMode: boolean): void => {
	recoveryCodeModeSignal.value = isRecoveryCodeMode;
};

export default recoveryCodeModeSignal;
